import BookNowBox from "legacy/boater-reservation-flow/price-estimate/BookNowBox"
import PropTypes from "prop-types"
import React from "react"

class BookNowEstimate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.ifDockPrice = this.ifDockPrice.bind(this)
    this.ifMooringPrice = this.ifMooringPrice.bind(this)
  }

  ifDockPrice() {
    if (this.props.state.dockType === "Dock") {
      return (
        <BookNowBox
          state={this.props.state}
          routeTo={this.props.routeTo}
          name="Dock"
          price={this.props.dockPrice}
          setGlobalState={this.props.setGlobalState}
          marina={this.props.marina}
          embedForm={this.props.embedForm}
        />
      )
    }
  }

  ifMooringPrice() {
    if (this.props.state.dockType === "Mooring") {
      return (
        <BookNowBox
          state={this.props.state}
          routeTo={this.props.routeTo}
          name="Mooring"
          price={this.props.mooringPrice}
          setGlobalState={this.props.setGlobalState}
          marina={this.props.marina}
          embedForm={this.props.embedForm}
        />
      )
    }
  }

  render() {
    return (
      <div id="bookNowEstimate">
        <hr />
        <div className="book-now-wrapper">
          {this.ifDockPrice()}
          {this.ifMooringPrice()}
        </div>
      </div>
    )
  }
}

BookNowEstimate.propTypes = {
  state: PropTypes.shape({
    estimateBtnPressed: PropTypes.bool,
    initialPriceEstimate: PropTypes.bool,
    boatCreated: PropTypes.string,
    draftMissing: PropTypes.bool,
    heightMissing: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    draft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dockwaBalanceAmount: PropTypes.number,
    minNightRequirement: PropTypes.number,
    nextDisabled: PropTypes.bool,
    dockType: PropTypes.string,
  }),
  routeTo: PropTypes.func.isRequired,
  dockPrice: PropTypes.number,
  mooringPrice: PropTypes.bool,
  setGlobalState: PropTypes.func.isRequired,
  marina: PropTypes.object.isRequired,
  embedForm: PropTypes.bool,
}

export default BookNowEstimate
